import { TextInput } from 'react-admin';
import ArrayForm from './ArrayForm';
import BoundedInput from './BoundedInput';

const ArraySharingNameDescription = ({ index, source, }: { source: string, index: number }) => {
    return (
        <ArrayForm source={source} grid={0} simpleFormIteratorProps={{
          sx: {
              '& .RaSimpleFormIterator-form': {
                  display: 'grid',
                  gap: '0px',
                  columnGap: '10px',
                  gridTemplateAreas: `
'name_en name_en name_tc name_tc name_sc name_sc'
'description_en description_en description_tc description_tc description_sc description_sc'
`
              }
          }
      }}>
            <BoundedInput source={`name_en`} input={<TextInput source="dummy" />} />
            <BoundedInput source={`name_tc`} input={<TextInput source="dummy" />} />
            <BoundedInput source={`name_sc`} input={<TextInput source="dummy" />} />
            <BoundedInput source={`description_en`} label="Description EN" input={<TextInput source="dummy" multiline />}/>
            <BoundedInput source={`description_tc`} label="Description TC" input={<TextInput source="dummy" multiline />}/>
            <BoundedInput source={`description_sc`} label="Description SC" input={<TextInput source="dummy" multiline />}/>            
        </ArrayForm>
    )
}

export default ArraySharingNameDescription;